import { render, staticRenderFns } from "./modal-politicas.vue?vue&type=template&id=25e651dc&scoped=true"
import script from "./modal-politicas.vue?vue&type=script&lang=js"
export * from "./modal-politicas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e651dc",
  null
  
)

export default component.exports